import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { isLocalhost } from "../../util/helpers";
import PrimeKYCLogo from '../../image/prime-kyc-logo.svg';
import "./LandingPage.style.scss";
import { useLocation } from "react-router-dom";

const SideMenu = props => {
  const loggedUserInfo = useSelector((state) => state.loggedUserInfo);
  const environment = isLocalhost()
    ? "http://kyc.localhost.com:3010"
    : process.env.REACT_APP_NEW_HOST;
  const { pathname } = useLocation();
  const [isFileCollapse, setFileCollapse] = useState(false);
  const [isMonitorCollapse, setMonitorCollapse] = useState(false);

  useEffect(() => {
    const shouldFileCollapse = [
      "/CompaniesLanding",
      "/EbinderMainLanding",
      "/IndividualEntitiesLanding",
      "/UnitTrustRegisterLanding",
      "/JointHolderLanding",
      "/BusinessNameLanding",
      "/DIDListLanding",
    ].includes(pathname);
    const shouldMonitorCollapse = [
    "/MonitorLanding",
    "/ASICDeptLanding",
    "/OrderMonitorLanding",
    "/DigitalSignatureLanding",
    "/FormsAndDocumentsLanding",
  ].includes(pathname) || pathname.includes("/MonitorLanding");

    setMonitorCollapse(shouldMonitorCollapse);
    setFileCollapse(shouldFileCollapse);
  }, [pathname]);

  

  return (
    <div className="col-auto px-4 py-3 px-sm-4 leftNavSideMenu" style={{ width: '14.5rem' }}>
      <div className="text-white d-flex flex-column align-items-center align-items-sm-start" style={{ height: '97vh' }} id="menu">
        <div>
          <img src="/prime_compliance_logo.jpg" width="180" alt="Prime Compliance Logo" />
        </div>
        <br />
        <a
          href={() => false}
          className="pb-3 text-white d-flex align-items-center mb-md-0 me-md-auto text-decoration-none"
        >
          <div className="rcorners1">
            <span className="companyInitial">
              {loggedUserInfo &&
                loggedUserInfo.items &&
                loggedUserInfo.items.ClientName.charAt(0).toUpperCase()}
            </span>
          </div>
          <span className="px-2 pb-1 fs-7 d-none d-sm-inline">
            {loggedUserInfo &&
              loggedUserInfo.items &&
              loggedUserInfo.items.ClientID}{" "}
            <br />
          </span>
        </a>
        <span className="px-0 pb-1 fs-7 d-none d-sm-inline text-secondary">
          Discover
        </span>
        <ul className="mb-0 nav flex-column w-100 mh-75 overflow-auto flex-nowrap">
          <li className="nav-item ">
            <a
              href={() => false}
              className={
                "nav-link align-middle px-2 " +
                (["/", "/CompanyMenuDetails"].includes(pathname) ? "selected" : "")
              }
              onClick={() => props.history.push("/CompanyMenuDetails")}
            >
              <i className="bi bi-building text-secondary"></i>

              <span className="ms-1 d-none d-sm-inline">Company</span>
            </a>
          </li>

          {loggedUserInfo &&
            loggedUserInfo.items &&
            !loggedUserInfo.items.ExcludeDeparmentalActions && (
              <li className="nav-item ">
                <a
                  href="#submenu2"
                  data-bs-toggle="collapse"
                  className="px-0 px-2 align-middle nav-link"
                >
                  <i className="fs-6 bi-files text-secondary"></i>{" "}
                  <span className="ms-1 d-none d-sm-inline">Files</span>
                </a>
                <ul
                  className={
                    isFileCollapse
                      ? "collapse show nav flex-column ms-1"
                      : "collapse nav flex-column ms-1"
                  }
                  id="submenu2"
                  data-bs-parent="#menu"
                >
                  <li className="w-100">
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/CompaniesLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/CompaniesLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">Companies</span>
                    </a>
                  </li>

                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/EbinderMainLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/EbinderMainLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">eBinders</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/IndividualEntitiesLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/IndividualEntitiesLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">
                        Individuals & Entities
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/UnitTrustRegisterLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/UnitTrustRegisterLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">
                        Unit Trusts
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/JointHolderLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/JointHolderLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">
                        Joint Holders
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/BusinessNameLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/BusinessNameLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">
                        Business Names
                      </span>
                    </a>
                  </li>
                  {/*  <li>
                <a
                  href={() => false}
                  className={
                    "nav-link px-4 " +
                    (props.isBenificalOwnerPage ? "selected" : "")
                  }
                  onClick={() =>
                    props.history.push("/BeneficialOwnerLanding")
                  }
                >
                  <i
                    className={
                      props.isBenificalOwnerPage
                        ? "bi bi-heart-fill text-dark"
                        : "bi bi-heart-fill"
                    }
                  ></i>{" "}
                  <span
                    className={
                      props.isBenificalOwnerPage
                        ? "d-none d-sm-inline text-dark"
                        : "d-none d-sm-inline"
                    }
                  >
                    {" "}
                    Beneficial Owners & Trusts
                  </span>
                </a>
                  </li>
                  */}
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/DIDListLanding" ? "selected" : "")
                      }
                      onClick={() => props.history.push("/DIDListLanding")}
                    >
                      <span className="d-none d-sm-inline">
                        Director ID
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
            )}
          {loggedUserInfo &&
            loggedUserInfo.items &&
            !loggedUserInfo.items.ExcludeDeparmentalActions && (
              <li className="nav-item ">
                <a
                  href="#submenu3"
                  data-bs-toggle="collapse"
                  className="px-0 px-2 align-middle nav-link"
                >
                  <i className="bi bi-laptop text-secondary"></i>{" "}
                  <span className="ms-1 d-none d-sm-inline ">Monitors</span>
                </a>
                <ul
                  className={
                    isMonitorCollapse
                      ? "collapse show nav flex-column ms-1"
                      : "collapse nav flex-column ms-1"
                  }
                  id="submenu3"
                  data-bs-parent="#menu"
                >
                  <li className="w-100">
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        ((pathname === "/MonitorLanding" || pathname.includes("/MonitorLanding")) ? "selected" : "")
                      }
                      onClick={() => props.history.push("/MonitorLanding")}
                    >
                      <span className="d-none d-sm-inline">
                        Annual Statements
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/ASICDeptLanding" ? "selected" : "")
                      }
                      onClick={() => props.history.push("/ASICDeptLanding")}
                    >
                      <span className="d-none d-sm-inline">ASIC Debts</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/OrderMonitorLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/OrderMonitorLanding")
                      }
                    >
                      <i></i>{" "}
                      <span className="d-none d-sm-inline">Orders</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/DigitalSignatureLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/DigitalSignatureLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">
                        Digital Signatures
                      </span>
                    </a>
                  </li>

                  <li>
                    <a
                      href={() => false}
                      className={
                        "nav-link px-4 " +
                        (pathname === "/FormsAndDocumentsLanding" ? "selected" : "")
                      }
                      onClick={() =>
                        props.history.push("/FormsAndDocumentsLanding")
                      }
                    >
                      <span className="d-none d-sm-inline">
                        ASIC Forms Portal
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
            )}
        </ul>
        <ul className="mb-0 nav flex-column w-100 mt-sm-auto">
          <li className="nav-item ">
            <a
              href="#submenu4"
              data-bs-toggle="collapse"
              className="px-0 px-2 align-middle nav-link position-relative"
            >
              <i className="fs-6 bi-app-indicator text-secondary"></i>{" "}
              <span className="ms-1 d-none d-sm-inline">Prime Platforms</span>
              <i className="fs-6 bi-chevron-down text-secondary position-absolute top-50 end-0 translate-middle m-0"></i>
            </a>
            <ul
              className="nav collapse flex-column ms-1"
              id="submenu4"
              data-bs-parent="#menu"
            >
              <li className="w-100">
                <a href={`${environment}/#/know-your-customer`} target="_blank" rel="noreferrer" className="d-none d-sm-inline">
                  <div className="py-2 px-3 flex justify-center rounded-lg border border-navy-300 group hover:bg-[#1e5a9c]" style={{ background: ' #133a64', width: '100%', borderRadius: '0.5rem' }}>
                    <img src={PrimeKYCLogo} alt="Prime KYC Logo" className="w-100" />
                  </div>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  )
}

export default SideMenu;